export const rutRegex = /^[0-9]{12}$/g;

export const codRetencionRegex = /^[0-9]{7}$/g;

export const ciRegex = /^[0-9]{1}.[0-9]{3}.[0-9]{3}-[0-9]{1}/;

export const onlyNumbersRegex = /^[0-9]+$/;
